
import { getApi } from "./auth";
import $ from "jquery";
import ErrorTextStatus = JQuery.Ajax.ErrorTextStatus;


const trace = async () : Promise<void> => {
    
    const user = getApi().getCached("userInfo");
    let _userAnagraficaId: number = user.anagraficaId;
    if (_userAnagraficaId == null)
        _userAnagraficaId = 0;
    let _url = window.BaseUrlWeb + "/home/tracestats";
    let _obj = { userAnagraficaId: _userAnagraficaId };
    
    return new Promise<void>((resolve, reject) => {
        $.ajaxWithCredentials({
            url: _url,
            method: 'POST',
            data: _obj,
            success: function (data, textStatus, jqXHR) {
                resolve();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                reject({jqXHR, textStatus, errorThrown});
            }
        });
    });
    
}

export {trace};